var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_reset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_reset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 2,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 15,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 14,
    y2: 8,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 8,
    x2: 1,
    y2: 8,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9497475,
    y1: 3.05025253,
    x2: 12.2426407,
    y2: 3.75735931,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.75735931,
    y1: 12.2426407,
    x2: 3.05025253,
    y2: 12.9497475,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.9497475,
    y1: 12.9497475,
    x2: 12.2426407,
    y2: 12.2426407,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.75735931,
    y1: 3.75735931,
    x2: 3.05025253,
    y2: 3.05025253,
    id: "Line-3",
    stroke: "#000000",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon_reset.0601c787b7f215ee9e4e73836457bb2a.svg";
export { ForwardRef as ReactComponent };